import React from "react";

import { useNavigate } from "react-router-dom";

import { Button, Stack, Divider } from "@mui/material";

import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import ROUTES from "@app/common/routes";
import useWorkspace from "@app/common/workspaces/useWorkspace";
import { isWorkspaceOwner } from "@app/common/workspaces/workspaceUtils";

const AdminWorkspaceActions = ({
  onClickMigrateMeetings,
  onClickLeaveWorkspace,
}: {
  onClickMigrateMeetings: () => void;
  onClickLeaveWorkspace: () => void;
}) => {
  const navigate = useNavigate();
  const { workspaceUser } = useWorkspace();
  const isOwner = isWorkspaceOwner(workspaceUser);

  const handleClickTransferOwnership = () =>
    navigate(ROUTES.TRANSFER_WORKSPACE);

  const handleClickDeleteWorkspace = () => navigate(ROUTES.DELETE_WORKSPACE);

  return (
    <WorkspaceSettingsAccordion
      title="Workspace Actions"
      subtitle={
        isOwner
          ? "Migrate Meetings, Transfer Ownership, Delete Workspace"
          : "Migrate Meetings, Leave Workspace"
      }
    >
      <Stack direction="column" spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <SettingsTitle
            title="Migrate Meetings"
            subtitle="Move past meetings measured with Read to this Workspace for more robust trends and insights."
            sx={{ width: "100%" }}
          />
          <Button
            variant="text"
            sx={{ width: "200px", height: "44px" }}
            onClick={onClickMigrateMeetings}
          >
            Migrate Meetings
          </Button>
        </Stack>
        <Divider />
        {isOwner && (
          <>
            <Stack direction="row" spacing={2} alignItems="center">
              <SettingsTitle
                title="Transfer Ownership"
                subtitle="This action is permanent and cannot be undone."
                sx={{ width: "100%" }}
              />
              <Button
                variant="text"
                sx={{ width: "200px", height: "44px" }}
                onClick={handleClickTransferOwnership}
              >
                Transfer Ownership
              </Button>
            </Stack>
            <Divider />
          </>
        )}
        <Stack direction="row" spacing={2} alignItems="center">
          {isOwner ? (
            <>
              <SettingsTitle
                title="Delete Workspace"
                subtitle="This action is permanent and cannot be undone. You will lose access to the Workspace and all associated data."
                sx={{ width: "100%" }}
              />
              <Button
                variant="text"
                color="error"
                sx={{ width: "200px", height: "44px" }}
                onClick={handleClickDeleteWorkspace}
              >
                Delete Workspace
              </Button>
            </>
          ) : (
            <>
              <SettingsTitle
                title="Leave Workspace"
                subtitle="This action is permanent and cannot be undone. You will lose access to the Workspace and all associated data."
                sx={{ width: "100%" }}
              />
              <Button
                variant="text"
                color="error"
                sx={{ width: "200px", height: "44px" }}
                onClick={onClickLeaveWorkspace}
              >
                Leave Workspace
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </WorkspaceSettingsAccordion>
  );
};

export default AdminWorkspaceActions;
